export const tagOverrides = {
  Root: {
    style: ({
      $theme
    }) => ({
      margin: 0,
      padding: `${$theme.sizing.scale0} ${$theme.sizing.scale100}`,
      borderRadius: $theme.sizing.scale100
    })
  },
  Text: {
    style: ({
      $theme
    }) => ({
      ...$theme.typography.LabelXSmall,
      maxWidth: '100%'
    })
  },
  StartEnhancerContainer: {
    style: ({
      $theme
    }) => ({
      paddingRight: $theme.sizing.scale100
    })
  }
};
export const containerStyles = {
  display: 'flex',
  alignItems: 'center'
};